import { useConfigurationContext } from '../context/configurationContext'
import { useNavigationParams } from '../system/useNavigationParams'
import { useGlMapsForBlockAndLayer } from '../uiModels/glMapOperations/useGlMapsForBlockAndLayer'

/** The GL maps that apply at the location in view, on the date in view. */
export const useApplicationViewGlMaps = () => {
  const { layer, block } = useNavigationParams()
  const { viewAt } = useConfigurationContext()

  return useGlMapsForBlockAndLayer({ layer, block, viewAt })
}
